import { gql } from "@apollo/client";

export const USER_BASIC_INFO = gql`
  fragment UserBasicInfo on UserObjectType {
    id
    uuid
    firstName
    lastName
    email
    username
    phoneNumber
    status
    isActive
    isStaff
    isSuperuser
    userType
    createdAt
    updatedAt
    dateJoined
    lastLogin
  }
`;

export const USER_PROFILE_INFO = gql`
  fragment UserProfileInfo on UserObjectType {
    dateOfBirth
    image {
      url
      alt
    }
    defaultLanguage
  }
`;

export const USER_MEMBERSHIP_INFO = gql`
  fragment UserMembershipInfo on UserObjectType {
    isMember
    memberId
    memberType
    twoFaMethod
    assignedEmployee {
      id
      firstName
      lastName
      email
    }
    note
    interest
  }
`;

// Removed USER_COMPANY_INFO - company not in schema

export const USER_SIMULATION_PREFERENCES = gql`
  fragment UserSimulationPreferences on UserSimulationPreferenceType {
    id
    investmentAmount
    currency
    locations
    company
    submittedFirstName
    submittedLastName
    submittedPhone
    submittedLanguage
    checked
    createdAt
    updatedAt
  }
`;

export const USER_FULL_INFO = gql`
  ${USER_BASIC_INFO}
  ${USER_PROFILE_INFO}
  ${USER_MEMBERSHIP_INFO}
  ${USER_SIMULATION_PREFERENCES}
  fragment UserFullInfo on UserObjectType {
    ...UserBasicInfo
    ...UserProfileInfo
    ...UserMembershipInfo
    simulationPreferences {
      ...UserSimulationPreferences
    }
  }
`;
